import { useEffect } from "react";

export default function GoogleRedirectBridge() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");

    if (error) {
      window.location.href = `/login?googleError=${encodeURIComponent(error)}`;
    } else if (code) {
      window.location.href = `/google-auth?code=${encodeURIComponent(code)}`;
    } else {
      console.warn("No code or error found in query params.");
    }
  }, []);

  return <div>Redirigiendo desde Google...</div>;
}
